export interface LocktubeData {
  badgeScanned: boolean;
  arrivalDismissed: string;
  rolloutCancelled: boolean;
  status: string;
  arrivalReadyForContinue: boolean;
  socialCue: string;
  tubes: {
    small: Locktube;
    medium: Locktube;
    large: Locktube;
  };
  scanResult: string;
  lastScanTimestamp: string;
  readyToCancel: boolean;
}

export interface Locktube {
  accessStatus: string;
  destination: string;
  disabled: boolean;
  filled: boolean;
  unlocked: boolean;
  reservedBy: string;
}

export interface Destination {
  id: number;
  drawer: string;
  name: string;
  note: string;
  taskId: string;
  pinCode: string;
}

export interface Tubes {
  small: Locktube;
  medium: Locktube;
  large: Locktube;
}

export enum ScanResult {
  Prohibited = 'PROHIBITED',
  Success = 'SUCCESS',
  NotRecognized = 'NOT_RECOGNIZED',
  Error = 'ERROR',
}
